import { reactive } from "vue";
import { Place } from "@/types/Place";
import { Attendee } from "@/types/Attendee";
import { Corpus } from "@/types/Corpus";

export interface MapFilterInterface {
    isOpen: boolean;
    menuIsOpen: boolean;
    fromDate: number;
    toDate: number;
    speakers: Attendee[];
    allSpeakers: Attendee[];
    places: any[];
    allPlaces: Place[];
    corpora: Corpus[];
    isLoading: boolean;
    placeMentions: Map<string, any>;
    visiblePlaces: Map<string, any>;
    inspectedPlace: [string, any] | null; //for modal
    inspectedPlaceSpeakers: any[] | null;
    dateRangeError: string;
}

export class MapFilter implements MapFilterInterface {
    isOpen: boolean = true;
    menuIsOpen: boolean = false;
    fromDate: number = 1861;
    toDate: number = 1939;
    speakers: Attendee[] = [];
    allSpeakers: Attendee[] = [];
    places: any[] = [];
    allPlaces: Place[] = [];
    corpora: Corpus[] = [];
    isLoading: boolean = false;
    placeMentions: Map<string, any> = new Map<string, any>();
    visiblePlaces: Map<string, any> = new Map<string, any>();
    inspectedPlace: [string, any] | null = null;
    inspectedPlaceSpeakers: any[] | null = null;
    dateRangeError: string =  '';

    static create(): MapFilter {
        return reactive(new MapFilter()) as MapFilter;
    }
}
